import { batch6Foundations } from './batch6/foundations.ts';
import { batch6Reading } from './batch6/reading.ts';
import { batch6Math } from './batch6/math.ts';
import { batch6Reason } from './batch6/reason.ts';
import { batch5Foundations } from './batch5/foundations.ts';
import { batch5Reading } from './batch5/reading.ts';
import { batch5Math } from './batch5/math.ts';
import { batch5Reason } from './batch5/reason.ts';
import { batch4Reason } from './batch4/reason.ts';
import { batch4Math } from './batch4/math.ts';
import { batch4Reading } from './batch4/reading.ts';
import { batch4Foundations } from './batch4/foundations.ts';
import { batch3Reason } from './batch3/reason.ts';
import { batch3Math } from './batch3/math.ts';
import { batch3Reading } from './batch3/reading.ts';
import { batch3Foundations } from './batch3/foundations.ts';
import { batch2Reason } from './batch2/reason.ts';
import { batch2Math } from './batch2/math.ts';
import { batch2Reading } from './batch2/reading.ts';
import { batch2Foundations } from './batch2/foundations.ts';
import { reason } from './reason.ts';
import { math } from './math.ts';
import { reading } from './reading.ts';
import { foundations } from './foundations.ts';
import type { Category, Exercise } from '../types.ts';
export const content: Record<Category, Exercise[]> = {
  reason: [
    ...reason,
    ...batch2Reason,
    ...batch3Reason,
    ...batch4Reason,
    ...batch5Reason,
    ...batch6Reason,
  ],
  math: [...math, ...batch2Math, ...batch3Math, ...batch4Math, ...batch5Math, ...batch6Math],
  reading: [
    ...reading,
    ...batch2Reading,
    ...batch3Reading,
    ...batch4Reading,
    ...batch5Reading,
    ...batch6Reading,
  ],
  foundations: [
    ...foundations,
    ...batch2Foundations,
    ...batch3Foundations,
    ...batch4Foundations,
    ...batch5Foundations,
    ...batch6Foundations,
  ],
};
export const exercises: Exercise[] = Object.values(content).flat();
export const byId = Object.fromEntries(exercises.map((item) => [item.id, item]));
export function findQuestion(exercise: Exercise, id?: string) {
  return (
    exercise.questions.find((question) => question.id === id) ??
    exercise.retiredQuestions?.find((question) => question.id === id)
  );
}
